import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseDataService, HttpResponsesHandlersFactory } from "@bbwt/modules/data-service";
import { IncompleteDataAccessRequest } from "./incomplete-data-access-request";
import { SetLocalTimeZone } from "@bbwt/utils";
import { IQueryCommand } from "@features/filter";
import { IPagedData } from "@features/grid";
import { setPageFieldsLocalTimeZone } from "@mipro/classes/date-utils";

@Injectable()
export class IncompleteDataRequestsService extends BaseDataService {
    readonly url = "api/incomplete-data/requests";

    constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
        super(http, handlersFactory);
    }

    async getPage(queryCommand: IQueryCommand) {
        const page = await this.handle(this.http.get<IPagedData<IncompleteDataAccessRequest>>(`${this.url}/page`));

        setPageFieldsLocalTimeZone(page, "requestDate");

        return page;
    }

    async getPatientPrompts() {
        const requests = await this.handle(this.http.get<IncompleteDataAccessRequest[]>(`${this.url}/prompts`));
        requests.forEach(request => (request.requestDate = SetLocalTimeZone(request.requestDate)));

        return requests;
    }

    grantAccess(requestId: string) {
        return this.handle(this.http.post<void>(`${this.url}/${requestId}/grant`, null));
    }

    grantManualAccessAll() {
        return this.handle(this.http.post<void>(`${this.url}/grant-manual-all`, null));
    }

    grantAutomaticAccessAll() {
        return this.handle(this.http.post<void>(`${this.url}/grant-automatic-all`, null));
    }

    markPatientPrompts() {
        return this.handle(this.http.put<void>(`${this.url}/prompts/mark`, null));
    }

    getOrgnaizationsToBeGranted(requestId: string) {
        return this.handle(this.http.get<string[]>(`${this.url}/${requestId}/organizations-to-be-granted`));
    }
}
